// 用来获取手游游戏对应平台的下载信息
var $ = require('jquery')
  , detector = require('widgets/detector.js')
  , GetDownloadUrls = require('widgets/getDownloadUrls')

module.exports = function getDownloadInfo() {
  var getDownloadurls = new GetDownloadUrls()
    , newGameCode = null
    , isIos = false

  if (detector.isiOS()) {
    for(var p in ued.newgameCodes){
      if(p == 'iOS'){
        newGameCode = ued.newgameCodes.iOS
        isIos = true
        break;
      }
    }
  }

  if (detector.isAndroid()) {
    for(var p in ued.newgameCodes){
      if(p == 'Android'){
        newGameCode = ued.newgameCodes.Android
        break;
      }
    }
  }

  if (newGameCode == null) {
    return false;
  }

  var dfd = new $.Deferred()
  $.when(getDownloadurls.getPlatformUrl(newGameCode)).then(function(res) {
    return dfd.resolve({url:res.data, isIos:isIos})
  })
  return dfd.promise()
}